export const ADVANCED_SKELETON_COUNTS = { _3: 3, _4: 4, _5: 5, _15: 15 };
